import Vue from 'vue';
import URI from 'urijs'
import { config } from '@/plugins/env.config'

async function getBeneficiary(beneficiaryId, attemptNumber = 1) {
  
  const getBeneficiaryUri = new URI(config.apiBaseUrl)
  getBeneficiaryUri.segment('plans')
  getBeneficiaryUri.segment('v1')
  getBeneficiaryUri.segment('beneficiaries')
  getBeneficiaryUri.segment(beneficiaryId.toString())

  try{
    return await Vue.prototype.$http.get(getBeneficiaryUri.toString())
  }catch(error) {
    const maxAttempts = config.getTokenMaxAttempts
    const attemptDelayInSeconds = config.getTokenAttemptDelayInSeconds

    const response = error.response
    const status = response.status

    if (status === 500 && attemptNumber < maxAttempts) {
      await new Promise(resolve => setTimeout(resolve, attemptDelayInSeconds * 1000))
      return getBeneficiary(beneficiaryId, attemptNumber + 1)
    }

    throw error
  }
}

export {
  getBeneficiary
}